export default __webpack_public_path__ + "assets/logos/53d106d7dd573a18917f5f3c73dd361f.png";